import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'tm-icon-toggler',
    templateUrl: './tm-icon-toggler.component.html',
    styleUrls: ['./tm-icon-toggler.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class TmIconTogglerComponent {
    @Input() public tmIconType: string;
}
